'use strict';

angular
    .module('myConsultApp')
    .directive(
        'petdetails',
        function (
            $cookieStore,
            $location,
            crumble,
            $routeParams,
            $rootScope,
            $window,
        ) {
            return {
                templateUrl: 'templates/petdetails.html',
                restrict: 'A',
                replace: true,
                link: function (scope, elem, attr) {
                    /*
				//Expand/Collapse pet details
				elem.find('.pet-details-trigger, .pet-name, .wrapperpetimg img').click(function(){
					$('.pet-details-trigger').toggleClass('active');

					var detailsHeight = $('.pet-details-content').innerHeight();
					var containerHeight = $('.panel-pet-details .panel-body').height();

					if(containerHeight > 0) {
						$('.panel-pet-details .panel-body').animate({ height: 0, marginBottom: 0 }, 400, function() {});
					}else {
						$('.panel-pet-details .panel-body').animate({ height: detailsHeight}, 400, function() {});
					}
					$('.panel-pet-details').toggleClass('open');
				});
				*/

                    scope.isMobile = function () {
                        var result = $window.innerWidth < 480;
                        return result;
                    };

                    scope.getProfileImage = function (src) {
                        if (src !== '' && src !== null) {
                            return src;
                        } else {
                            if (scope.currentPet.species == 1) {
                                return 'images/default-canine-profile.png';
                            } else {
                                return 'images/default-feline-profile.png';
                            }
                        }
                    };
                    scope.crumbleGenerated = false;
                    scope.generatingCrumble = function () {
                        if (
                            scope.currentPet &&
                            scope.crumbleGenerated == false &&
                            !scope.retrievingPet
                        ) {
                            crumble.update();
                            scope.crumble = crumble;
                            if (scope.crumble.trail[1].label.indexOf('Administrative') !== -1) {
                                scope.crumble.trail[3].label = scope.currentPet.name;
                            } else {
                                scope.crumble.trail[2].label = scope.currentPet.name;
                            }
                            if (scope.crumble.trail[3] && scope.crumble.trail[4]) {
                                console.log(scope.crumble.trail);
                            }
                            $rootScope.crumble = scope.crumble;
                            scope.crumbleGenerated = true;

                            return true;
                        } else if (scope.crumbleGenerated == false) {
                            return false;
                        } else {
                            return true;
                        }
                    };

                    function adjustProfileInfo() {
                        //adjust Profile Info on window resize
                        var detailsHeight = $('.pet-details-content').innerHeight();
                        var containerHeight = $('.panel-pet-details .panel-body').height();
                        if (containerHeight > 0) {
                            $('.panel-pet-details .panel-body').animate(
                                { height: detailsHeight, marginBottom: '-115px' },
                                400,
                                function () {}
                            );
                        }
                    }
                    angular.element(window).resize(function () {
                        adjustProfileInfo();
                    });

                    $('a.lightbox').easybox({});

                    elem.find('#closePopUp').click(function (e) {
                        e.preventDefault();
                        if ($.easybox.isOpen()) {
                            $.easybox.close();
                        }
                    });

                    scope.selectPet = function (pet) {
                        scope.setCurrentPet(pet);
                        $.easybox.close();
                    };
                }
            };
        }
    );
